import React, { useEffect, useState, useRef } from 'react';
import './header_busq.css'
import { useTranslation } from 'react-i18next';

import lupa from '../../../assets/img/lupa.png';

const Header_busq = ({ titulo, blogs, ideas, libros }) => {
    const [t, i18n] = useTranslation("busqueda");
    const [inputVal, setInputVal] = useState('');
    const handleInputChange = (event) => {
        setInputVal(event.target.value);
    };
    const handleClick = () => {

        window.location.href = "/es/busqueda/" + inputVal;
    };

    const renderizarlinks = () => {
        var htmllinks = "";
        if (blogs === 0) {
            htmllinks = '<a class="noh">0 ' + (t('header.res1')) + '</a>';
        }
        else {
            if (blogs === 1) {
                htmllinks = '<a href="#bus_blogs" class="sih">1 ' + (t('header.res1_1')) + '</a>';
            }
            else {
                htmllinks = '<a href="#bus_blogs" class="sih">' + blogs + ' ' + (t('header.res1')) + '</a>';
            }

        }

        if (ideas === 0) {
            htmllinks = htmllinks + '<a class="noh">0 ' + (t('header.res2')) + '</a>';
        }
        else {
            if (ideas === 1) {
                htmllinks = htmllinks + '<a href="#bus_ideas" class="sih">1 ' + (t('header.res2_1')) + '</a>';
            }
            else {
                htmllinks = htmllinks + '<a href="#bus_ideas" class="sih">' + ideas + ' ' + (t('header.res2')) + '</a>';
            }
        }

        if (libros === 0) {
            htmllinks = htmllinks + '<a class="noh">0 ' + (t('header.res3')) + '</a>';
        }
        else {
            if (libros === 1) {
                htmllinks = htmllinks + '<a href="#bus_libros" class="sih">1 ' + (t('header.res3_1')) + '</a>';
            }
            else {
                htmllinks = htmllinks + '<a href="#bus_libros" class="sih">' + libros + ' ' + (t('header.res3')) + '</a>';
            }
        }

        return <div className='rest_res' dangerouslySetInnerHTML={{ __html: htmllinks }} />;
    };

    const handleKeyDown = (e) => {
        // Verificar si la tecla presionada es "Enter" (código 13)
        if (e.key === 'Enter') {
            handleClick();
        }
    };

    const clearSearch = () => {
        setInputVal('');
    };

    return (
        <div className='head_busq'>
            <div className='head_busq_1'>
                <p className="txt_entrada">{(t('header.titulo'))}</p>
                <div className='input_div'>
                    <input className="input_busqueda" type="text"
                        // placeholder='Ingresa el tema de tu interés'
                        placeholder={(t('header.campo_texto'))}
                        value={inputVal}
                        onChange={handleInputChange}
                        onKeyDown={handleKeyDown}
                    />
                    {inputVal && (
                        <button
                            onClick={clearSearch}
                            className='btn-srch-inpt'
                        >
                            &#x2715; {/* Esto es el símbolo de "X" */}
                        </button>
                    )}
                    <button className='btn_busqueda_idea' onClick={handleClick}>
                        <img className="lupa_IC" src={lupa} alt="Buscar" />
                    </button>
                </div>
            </div>
            <div className='head_busq_2'>
                <p className='rest_tit'>{(t('header.resultados'))} <span className='rest_tit2'>{titulo}</span></p>
                {renderizarlinks()}
            </div>

        </div>
    );

}

export default Header_busq;